import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Header';
import { useConfig } from '../../contexts/ConfigContext';

const Layout = ({ children }) => {
  const location = useLocation();
  const { isConfigured } = useConfig();
  
  // Don't show header on configuration page or if not configured
  const showHeader = isConfigured && location.pathname !== '/config';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {showHeader && <Header />}
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          backgroundColor: 'background.default',
          padding: showHeader ? 3 : 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
